import React from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import Button from 'rebook/apps/base/components/Button';
import UserSettingsHeader from 'rebook/apps/users/components/UserSettingsHeader';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { URLS } from 'rebook/apps/base/constants';

import UserSubscriptionListSubscriptionData from './UserSubscriptionListSubscriptionData';
import styles from './style.scss';


class UserSubscriptionListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptionList: null,
    };
    this.props.SeoActions.setData({
      title: 'Настройки вашего профиля и история покупок',
    });
  }

  createSubscriptionList() {
    const { user } = this.props;
    if (user) {
      let subscriptionList = [];

      // Add pro subscription
      if (user.subscription_pro_active_till) {
        subscriptionList.push({
          id: 2,
          activeTill: user.subscription_pro_active_till,
          type: 'pro',
          wallets: null,
          hasAutorebillWallets: false,
        });
      }

      // Add standard subscription
      if (user.subscription_standard_active_till) {
        subscriptionList.push({
          id: 1,
          activeTill: user.subscription_standard_active_till,
          type: 'standard',
          wallets: null,
          hasAutorebillWallets: false,
        });
      }

      // Add audio subscription
      if (user.subscription_audio_active_till) {
        subscriptionList.push({
          id: 3,
          activeTill: user.subscription_audio_active_till,
          type: 'audio',
          wallets: null,
          hasAutorebillWallets: false,
        });
      }

      // Add user subscriptions data
      this.setState({ subscriptionList }, () => {
        this.fetchWallets();
      });
    }

    else {
      this.setState({ subscriptionList: null });
    }
  }

  fetchWallets() {
    fetchQuery('/api/wallets/')
      .then(
        ({ data }) => {
          // Wallets data from wallets list grouped by subscription type
          let wallets = {
            standard: [],
            pro: [],
            audio: [],
          };
          data.objects.forEach((wallet) => {
            const subType = get(wallet, 'subscription_type', 'standard');
            wallets[subType].push(wallet);
          });

          // Has standard subscription and:
          const subscriptionList = this.state.subscriptionList.map(
            (subscription) => {
              return {
                ...subscription,
                wallets: wallets[subscription.type].length > 0 ? wallets[subscription.type] : null,
                hasAutorebillWallets: wallets[subscription.type].filter((item) => item.is_deactivatable).length > 0,
              };
            }
          );

          this.setState({ subscriptionList });
        }
      )
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('failed to fetch wallets due to error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              data,
              error,
            },
          });
        }
      );
  }

  removeWallet(walletId) {
    let subscriptionList = [];
    this.state.subscriptionList.forEach((item) => {
      let subscription = item;
      if (get(item, 'wallets.length', 0)) {
        subscription.wallets = item.wallets.filter((wallet) => wallet.id !== walletId);
      }
      subscriptionList.push(subscription);
    });
    this.setState({ subscriptionList });
  }

  componentDidMount() {
    if (!this.props.user) {
      return;
    }
    this.createSubscriptionList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.createSubscriptionList();
    }
  }

  render() {
    const { user } = this.props;
    if (!user) {
      return <Redirect to={URLS.authForm} />;
    }
    const { subscriptionList } = this.state;
    const hasAutorebillDescription = subscriptionList && subscriptionList.filter(
      (item) => item.hasAutorebillWallets
    ).length > 0;

    return (
      <div className={classNames(
        'backgroundContainer',
        'themeGrey',
        subscriptionList && subscriptionList.length === 0 && styles.emptySubscriptionList
      )}>
        <UserSettingsHeader page="userSubscriptionList" history={this.props.history}>
          <div className={styles.blockWrapper}>
            {subscriptionList
              ? (
                <React.Fragment>
                  <div className="jest-subscription-list">
                    {subscriptionList.length > 0
                      ? (
                        subscriptionList.map((item) => (
                          <UserSubscriptionListSubscriptionData
                            {...item}
                            onDeactivateWallet={(walletId) => this.removeWallet(walletId)}
                            key={item.id} />
                        ))
                      )
                      : (
                        <div className={styles.emptySubscriptionListContent}>
                          <div className="title-2">У вас нет подписки, и самое время ее подключить</div>
                          <div className={styles.emptySubscriptionListLinks}>
                            <Button link={URLS.payments} extraClassName={styles.emptySubscriptionListLink}>
                              Оформить подписку
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  </div>
                  {hasAutorebillDescription && (
                    <div className={styles.autoRebillingNote}>
                      <p>
                        <small>
                          При отключении автопродления книги будут доступны до последнего дня оплаченной подписки.
                          Следующее списание не произойдет и подписка закончится.
                        </small>
                      </p>
                    </div>
                  )}
                </React.Fragment>
              )
              : (
                [...Array(2)].map((item, i) => (
                  <div className="billetContainer" key={i + 1}>
                    <div className="title-1 elementDummy" />
                    <div className="title-2 elementDummy" />
                    <div className="title-2 elementDummy" />
                    <div className="title-2 elementDummy" />
                    <div className="title-2 elementDummy" />
                  </div>
                ))
              )
            }
          </div>
        </UserSettingsHeader>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserSubscriptionListView);
